import { z } from 'zod';
import { componentStyleSchema } from '../component-catalog.js';
const commonOptionals = {
    queryConfig: z.record(z.string(), z.unknown()).optional(),
    minimized: z.boolean().optional(),
    displayConfig: z.record(z.string(), z.unknown()).optional(),
    annotations: z.array(z.record(z.string(), z.unknown())).optional(),
    style: componentStyleSchema.optional(),
};
const propsSchema = z
    .object({
    sourceDataset: z.string(),
    mapping: z
        .object({
        xLabels: z.string(),
        yLabels: z.string(),
        value: z.string(),
    })
        .strict(),
    ...commonOptionals,
})
    .strict();
export const heatmapDefinition = {
    type: 'Heatmap',
    category: 'data',
    propsSchema,
    isDataBacked: true,
    columnRefManifest: ['xLabels', 'yLabels', 'value'],
    needsMeasuredDims: true,
    defaultMinHeight: 200,
    description: 'Heatmap over a dataset. Props: sourceDataset (required), mapping ({ xLabels: string, yLabels: string, value: string }).',
};
//# sourceMappingURL=Heatmap.js.map